import React, { useState } from "react";
import { ABtn, AResult } from "./arcadeUi";

const MAP = { F: "Friends 🤝", L: "Love ❤️", A: "Affection 🥰", M: "Marriage 💍", E: "Enemy 😾", S: "Siblings 👫" };

function flames(n1, n2) {
  const a = n1.toLowerCase().replace(/[^a-z]/g, "").split("");
  const b = n2.toLowerCase().replace(/[^a-z]/g, "").split("");
  for (let i = 0; i < a.length; i++) {
    const j = b.indexOf(a[i]);
    if (j > -1) { b.splice(j, 1); a.splice(i, 1); i--; }
  }
  let count = a.length + b.length;
  if (count === 0) return null;
  let arr = ["F", "L", "A", "M", "E", "S"];
  let idx = 0;
  while (arr.length > 1) {
    idx = (idx + count - 1) % arr.length;
    arr.splice(idx, 1);
    idx = idx % arr.length;
  }
  return arr[0];
}

export default function Flames() {
  const [n1, setN1] = useState("");
  const [n2, setN2] = useState("");
  const [out, setOut] = useState(undefined); // undefined=not run, null=invalid, letter
  const go = () => setOut(flames(n1, n2));

  return (
    <div className="w-full text-center">
      <p className="mb-4 text-sm text-kirana-brown/70">Recess ka sabse bada suspense 😄 — enter two names.</p>
      <div className="mx-auto flex max-w-sm flex-col gap-3">
        <input data-testid="flames-name1" value={n1} onChange={(e) => setN1(e.target.value)} placeholder="First name"
          className="rounded-md border-[3px] border-kirana-brown bg-white px-3 py-2.5 text-center font-bold text-kirana-brown outline-none focus:border-kirana-red" />
        <span className="font-signboard text-2xl text-kirana-red">💘</span>
        <input data-testid="flames-name2" value={n2} onChange={(e) => setN2(e.target.value)} placeholder="Second name"
          className="rounded-md border-[3px] border-kirana-brown bg-white px-3 py-2.5 text-center font-bold text-kirana-brown outline-none focus:border-kirana-red" />
      </div>
      <div className="mt-4 flex justify-center gap-2">
        <ABtn data-testid="flames-go" onClick={go} tone="red" disabled={!n1.trim() || !n2.trim()}>Calculate FLAMES</ABtn>
        {out !== undefined && <ABtn data-testid="flames-reset" onClick={() => { setN1(""); setN2(""); setOut(undefined); }}>Reset</ABtn>}
      </div>
      <div className="mt-4 flex justify-center gap-1.5">
        {["F", "L", "A", "M", "E", "S"].map((c) => (
          <span key={c} className={`flex h-9 w-9 items-center justify-center rounded-full border-2 border-kirana-brown font-signboard text-lg font-bold ${out === c ? "bg-kirana-red text-white" : "bg-kirana-cream text-kirana-brown/70"}`}>{c}</span>
        ))}
      </div>
      {out !== undefined && (
        <AResult testId="flames-result" win={out ? true : false}
          text={out ? MAP[out] : "Same person? 🙃 Try two different names"} />
      )}
    </div>
  );
}
